import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const receiveHubMessage = createAction(`${actionKey}.RECEIVE_MESSAGE`, (channel, data)=>({
        channel,
        data
    }));
